import './index.scss';
import BackButton from "../Buttons/BackButton";
import { useContext } from "react";
import Context from "../../../context";
import useKeypress from "../../../hooks/useKeypress";
import { useLocation, useNavigate } from "react-router-dom";
import { getEwaBackPath } from "../../../libraries/ewa/helpers";

const ListTitle = ({ backButton, backButtonPath, docScreenName }) => {
  const { removeItemsFromCustomHistory } = useContext(Context);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useKeypress('Escape', backButton, () => {
    if (!backButton.current) return
    backButton.current.click();
    navigate(backButton.current);
  });

  return (
    <div className="document-list-header">
      <BackButton
        className="back-button button"
        backButtonPath={backButtonPath}
        removeItemsFromCustomHistory={removeItemsFromCustomHistory}
        backButton={backButton}
        backButtonClickFn={() => {
          const ewaBackPath = getEwaBackPath();
          if (ewaBackPath && pathname === ewaBackPath?.entryPath) {
            localStorage.removeItem("ewaBackPath");
          }
        }}
      />
      <div className="title">{docScreenName}</div>
    </div>
  )
};
export default ListTitle;
